import Head from 'next/head'
import React from 'react'
import styled from 'styled-components'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'

const DESCRIPTION =
  'Together with our compassionate Experts, we`re launching a Rebuild Hotline to help those who have lost their homes find a path forward. If you or a loved one has lost a home to the L.A. fires, we invite you to meet with an interior designer for a free one-hour virtual consultation to create your rebuilding plan. We`ll match you with the Expert best suited to your needs.'

const Iframe = styled('iframe')`
  width: 100%;
  height: inherit;
`

export const RebuildHotline = () => (
  <>
    <Head>
      <title>The Expert Trade Program</title>
      <meta name="description" content={DESCRIPTION} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Box
      width="100%"
      height={{ MOBILE: 'calc(100vh - 300px)', TABLET: 'calc(100vh - 150px)' }}
    >
      <Iframe
        className="airtable-embed"
        src="https://airtable.com/embed/appdfyKYPtFIJtzb0/shr3uuayhIDbpj8vw"
        title="airtable form"
      />
    </Box>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

RebuildHotline.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
